import { defineMessages } from 'react-intl';

export default defineMessages({
  reportColumnTitle: 'Report',
  languageColumnTitle: 'Language',
  graphCount: 'Content',

  confirmDeleteReport: 'Are you sure you want to delete {title}?',
  confirmDeleteReportDesc: 'All future distributions will stop.',
  deleteReportSuccess: '{title} deleted.',
  deleteReportFail: 'Something went wrong while deleting the report.',
  duplicateReportSuccess: '{title} duplicated.',
  duplicateReportFail: 'Something went wrong while duplicating the report',

  newReport: 'New report',
  createReport: 'Create report',
  reportTitleInputLabel: 'Title',
  reportTitleInputPlaceholder: 'Report title',
  reportTitleInputRequired: 'A report must have a title',
  createReportSuccess: '{title} created!',
  createReportFail: 'Something went wrong while creating the report.',
  preview: 'Preview',
  viewDelivery: 'View',
  deliveryDate: 'Delivery date',
  pastDeliveries: 'Past deliveries',
  noPastDeliveries: 'No deliveries yet.',

  basicsPanelTitle: 'Settings',
  contentPanelTitle: 'Content',
  deliveryPanelTitle: 'Delivery',
  settingsSavedMessage: 'Report settings saved!',
  contentSavedMessage: 'Report content saved!',
  deliverySavedMessage: 'Delivery settings saved!',

  downloadPDF: 'Download PDF',
  downloadXLS: 'Download Excel',
  languageFieldLabel: 'Language',
  reportDateRangeFieldLabel: 'Report date range',
  reportDateRangePlaceholder: 'Choose a general date range for the report',
  reportContentDateRangePlaceholder: 'Override report date range',
  reportTimeOffsetFieldLabel: 'Date offset',
  reportTimeOffsetFieldHelp: 'Adjust dates in the report this number of days.',
  reportTimeOffsetFieldError: 'Please enter a number',
  reportContentEmptyMessage: 'No content added yet.',
  descriptionFieldLabel: 'Description',
  descriptionFieldPlaceholder: 'General description of the report',
  emailSubjectFieldLabel: 'Title',
  emailSubjectFieldPlaceholder: 'Used as E-mail subject and delivered report title',
  emailSubjectFieldHelp: '{variable} can be used to dynamically insert the current period dates.',
  frequency: 'Frequency',
  latestDeliveryDate: 'Latest delivery',
  nextDeliveryDate: 'Next delivery',
  pdf: 'PDF',
  xls: 'Excel',
  deliveryStartFieldLabel: 'Start',
  deliveryEndFieldLabel: 'End',
  pdfAttachmentCheckboxLabel: 'Generate PDF',
  deliveryTextResponsesLabel: 'Deliver text responses in',
  recipients: 'Recipients',
  addRecipientTagLabel: 'Add recipient',
  sendTestEmailFieldLabel: 'Send test e-mail',
  sendTestEmailFieldDescription: 'It can take a couple of minutes for the email to arrive depending on the size of the report.',
  sendTestEmailFieldPlaceholder: 'E-mail',
  sendTestEmailButtonLabel: 'Send',
  sendTestEmailSuccess: 'Test e-mail sent!',
  sendTestEmailFail: 'Failed to send test e-mail. Please try again later.',

  errorSaving: 'Something went wrong while saving your report settings. Please try again later.',
  empty: "You don't have any reports yet.",
  loadingChart: 'Loading chart...',
  customDateRangeFieldLabel: 'Custom date range',
  poweredBy: 'Powered by',
  reportCreated: 'Report created',
  dataCollected: 'Data collected',
});
